// extracted by css-extract-rspack-plugin
export default {"warningTitle":"_UCQPbExU6Y06adf","headerWarning":"xWtYtFU0lgscvfKY","warningList":"gf8AR7PfEkYmCPlc"};